import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Router from "vue-router";
import PPTHome from "@/components/home";
import EquityCalculator from "@/components/equity-calculator/equity-calculator";
import HitCalculator from "@/components/hit-calculator/hit-calculator";
import RangeConstructor from "@/components/range-constructor/range-constructor";
import EquityMatrix from "@/components/equity-matrix/equity-matrix";
import GuidedAnalysesShouldYouCall from "@/components/guided-analyses/should-you-call/should-you-call";
import GuidedAnalysesShouldYouBluff from "@/components/guided-analyses/should-you-bluff/should-you-bluff";
import BreakevenPercentageForBluffingTheTurn from "@/components/breakeven-percentage-for-bluffing-the-turn/breakeven-percentage-for-bluffing-the-turn";
import ThreeBetCbetExplorer from "@/components/three-bet-cbet-explorer/three-bet-cbet-explorer";
import PPTSettings from "@/components/settings/settings";
import HandRankingsSettings from "@/components/settings/general/hand-rankings";
import SavedRangesSettings from "@/components/settings/general/saved-ranges";
import TiersSettings from "@/components/settings/general/tiers";
import IncludedSelectorsSettings from "@/components/settings/general/included-selectors";
import VisualSettings from "@/components/settings/general/visual";
import RakeAndTipSettings from "@/components/settings/equity-calculator/rake-and-tip";
import NumberOfSimulationsEquityCalculatorSettings from "@/components/settings/equity-calculator/number-of-simulations";
import InsightsEquityCalculatorSettings from "@/components/settings/equity-calculator/insights";
import IncludedCheckboxesSettings from "@/components/settings/hit-calculator/checkboxes/included";
import CollapsedByDefaultCheckboxesSettings from "@/components/settings/hit-calculator/checkboxes/collapsed-by-default";
import FiltersSettings from "@/components/settings/hit-calculator/checkboxes/filters";
import CheckedByDefaultSettings from "@/components/settings/hit-calculator/checkboxes/checked-by-default";
import NumberOfSimulationsHitCalculatorSettings from "@/components/settings/hit-calculator/number-of-simulations";
import InsightsHitCalculatorSettings from "@/components/settings/hit-calculator/insights";
import PPTBlog from "@/components/blog/blog";
import Blog_PriorProbabilityAndEstimatingYourWinrate from "@/components/blog/prior-probability-and-estimating-your-winrate";
import Blog_SummaryOfPokersOnePercent from "@/components/blog/summary-of-pokers-one-percent";
import Blog_ZoomOut from "@/components/blog/zoom-out";
import Blog_SpacedRepetitionAndPoker from "@/components/blog/spaced-repetition-and-poker";
import PPTHelp from "@/components/help/help";
import EquityCalculatorHelp from "@/components/help/equity-calculator-help";
import HitCalculatorHelp from "@/components/help/hit-calculator-help";
import EquityMatrixHelp from "@/components/help/equity-matrix-help";
import RangeConstructorHelp from "@/components/help/range-constructor-help";
import ShouldYouBluffHelp from "@/components/help/should-you-bluff-help";
import ShouldYouCallHelp from "@/components/help/should-you-call-help";
import BreakevenPercentageForBluffingTheTurnHelp from "@/components/help/breakeven-percentage-for-bluffing-the-turn-help";
import ThreeBetCbetExplorerHelp from "@/components/help/three-bet-cbet-explorer-help";
import QuickGuide from "@/components/help/quick-guide";
import BeginnersGuide from "@/components/help/beginners-guide";
import MadeHandsAndDraws from "@/components/help/made-hands-and-draws";
import PPTFaq from "@/components/help/faq";
import PPTAbout from "@/components/about";
import PPTContact from "@/components/contact";
import PPTPricing from "@/components/pricing";
import ShortDeckPricing from "@/components/short-deck-pricing";
import SignIn from "@/components/user/sign-in";
import PPTRegister from "@/components/user/register";
import ForgotPassword from "@/components/user/forgot-password";
import CreateNewPassword from "@/components/user/create-new-password";
import PPTAccount from "@/components/user/account";
import ChangePassword from "@/components/user/change-password";
import PPTPurchase from "@/components/user/purchase";
import ShortDeckPurchase from "@/components/user/short-deck-purchase";
import PPTUpgrade from "@/components/user/upgrade";
import ShortDeckEquityCalculator from "@/components/short-deck/short-deck-equity-calculator";
import ShortDeckHitCalculator from "@/components/short-deck/short-deck-hit-calculator";
import store from "@/store";

Vue.use(Router);

let router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: ShortDeckEquityCalculator,
      name: "home",
      meta: {
        title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator",
        narrow: true
      }
    },

    {
      path: "/:id",
      component: ShortDeckEquityCalculator,
      meta: {
        title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator",
        narrow: true
      }
    },

    {
      path: "/short-deck/equity-calculator",
      component: ShortDeckEquityCalculator,
      meta: {
        title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator"
      }
    },
    {
      path: "/short-deck/equity-calculator/:id",
      component: ShortDeckEquityCalculator,
      meta: {
        title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator"
      }
    },
    {
      path: "/short-deck/hit-calculator",
      component: ShortDeckHitCalculator,
      meta: {
        title: "Six Plus Hold’em | Short Deck | Hit Calculator",
        //requiresShortDeckAuth: true
      }
    },
    {
      path: "/short-deck/hit-calculator/:id",
      component: ShortDeckHitCalculator,
      meta: {
        title: "Six Plus Hold’em | Short Deck | Hit Calculator",
        //requiresShortDeckAuth: true
      }
    },
    {
      path: "/equity-calculator",
      component: EquityCalculator,
      meta: {
        title: "Six Plus Hold’em | Equity Calculator",
        requiresBasicAuth: true
      }
    },
    {
      path: "/equity-calculator/:id",
      component: EquityCalculator,
      meta: {
        title: "Six Plus Hold’em | Equity Calculator"
      }
    },
    {
      path: "/hit-calculator",
      component: HitCalculator,
      name: "hit calculator",
      meta: {
        title: "Six Plus Hold’em | Hit Calculator",
        requiresBasicAuth: true
      }
    },
    {
      path: "/hit-calculator/:id",
      component: HitCalculator,
      name: "hit calculator sharable",
      meta: {
        title: "Six Plus Hold’em | Hit Calculator"
      }
    },
    {
      path: "/range-constructor",
      component: RangeConstructor,
      meta: {
        title: "Six Plus Hold’em | Range Constructor",
        requiresPremiumAuth: true
      }
    },
    {
      path: "/range-constructor/:id",
      component: RangeConstructor,
      meta: {
        title: "Six Plus Hold’em | Range Constructor"
      }
    },
    {
      path: "/equity-matrix/",
      component: EquityMatrix,
      meta: {
        title: "Six Plus Hold’em | Equity Matrix",
        requiresPremiumAuth: true
      }
    },
    {
      path: "/equity-matrix/:id",
      component: EquityMatrix,
      meta: {
        title: "Six Plus Hold’em | Equity Matrix"
      }
    },
    {
      path: "/guided-analyses/should-you-bluff",
      component: GuidedAnalysesShouldYouBluff,
      meta: {
        title: "Six Plus Hold’em | Should You Bluff",
        requiresBasicAuth: true
      }
    },
    {
      path: "/guided-analyses/should-you-bluff/:id",
      component: GuidedAnalysesShouldYouBluff,
      meta: {
        title: "Six Plus Hold’em | Should You Bluff"
      }
    },
    {
      path: "/guided-analyses/should-you-call",
      component: GuidedAnalysesShouldYouCall,
      meta: {
        title: "Six Plus Hold’em | Should You Call",
        requiresBasicAuth: true
      }
    },
    {
      path: "/guided-analyses/should-you-call/:id",
      component: GuidedAnalysesShouldYouCall,
      meta: {
        title: "Six Plus Hold’em | Should You Call"
      }
    },
    {
      path: "/breakeven-percentage-for-bluffing-the-turn",
      component: BreakevenPercentageForBluffingTheTurn,
      meta: {
        title:
          "Six Plus Hold’em | Breakeven Percentage For Bluffing The Turn",
        requiresPremiumAuth: true
      }
    },
    {
      path: "/breakeven-percentage-for-bluffing-the-turn/:id",
      component: BreakevenPercentageForBluffingTheTurn,
      meta: {
        title:
          "Six Plus Hold’em | Breakeven Percentage For Bluffing The Turn"
      }
    },
    {
      path: "/three-bet-cbet-explorer",
      component: ThreeBetCbetExplorer,
      meta: {
        title: "Six Plus Hold’em | 3bet-Cbet Explorer",
        requiresPremiumAuth: true
      }
    },
    {
      path: "/three-bet-cbet-explorer/:id",
      component: ThreeBetCbetExplorer,
      meta: {
        title: "Six Plus Hold’em | 3bet-Cbet Explorer"
      }
    },
    {
      path: "/settings",
      component: PPTSettings,
      meta: {
        title: "Six Plus Hold’em | Settings",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/general/hand-rankings",
      component: HandRankingsSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Hand Rankings",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/general/saved-ranges",
      component: SavedRangesSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Saved Ranges",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/general/tiers",
      component: TiersSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Tiers",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/general/included-selectors",
      component: IncludedSelectorsSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Included Selectors",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/general/visual",
      component: VisualSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Visual",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/equity-calculator/rake-and-tip",
      component: RakeAndTipSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Rake And Tip",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/equity-calculator/number-of-simulations",
      component: NumberOfSimulationsEquityCalculatorSettings,
      meta: {
        title:
          "Six Plus Hold’em | Settings | Equity Calculator Number Of Simulations",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/equity-calculator/insights",
      component: InsightsEquityCalculatorSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Equity Calculator Insights",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/checkboxes/included",
      component: IncludedCheckboxesSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Included Checkboxes",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/checkboxes/collapsed-by-default",
      component: CollapsedByDefaultCheckboxesSettings,
      meta: {
        title:
          "Six Plus Hold’em | Settings | Collapsed By Default Checkboxes",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/checkboxes/filters",
      component: FiltersSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Checkbox Filters",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/checkboxes/checked-by-default",
      component: CheckedByDefaultSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Checkboxes Checked By Default",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/number-of-simulations",
      component: NumberOfSimulationsHitCalculatorSettings,
      meta: {
        title:
          "Six Plus Hold’em | Settings | Hit Calculator Number Of Simulations",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/settings/hit-calculator/insights",
      component: InsightsHitCalculatorSettings,
      meta: {
        title: "Six Plus Hold’em | Settings | Hit Calculator Insights",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/blog",
      component: PPTBlog,
      meta: {
        title: "Six Plus Hold’em | Blog",
        narrow: true
      }
    },
    {
      path: "/blog/prior-probability-and-estimating-your-winrate",
      component: Blog_PriorProbabilityAndEstimatingYourWinrate,
      meta: {
        title:
          "Six Plus Hold’em | Blog | Prior Probability and Estimating Your Winrate",
        narrow: true
      }
    },
    {
      path: "/blog/summary-of-pokers-one-percent",
      component: Blog_SummaryOfPokersOnePercent,
      meta: {
        title: "Six Plus Hold’em | Blog | Summary of Pokers 1% by Ed Miller",
        narrow: true
      }
    },
    {
      path: "/blog/zoom-out",
      component: Blog_ZoomOut,
      meta: {
        title: "Six Plus Hold’em | Blog | Zoom out",
        narrow: true
      }
    },
    {
      path: "/blog/spaced-repetition-and-poker",
      component: Blog_SpacedRepetitionAndPoker,
      meta: {
        title: "Six Plus Hold’em | Blog | Spaced repetition and poker",
        narrow: true
      }
    },
    {
      path: "/help",
      component: PPTHelp,
      meta: {
        title: "Six Plus Hold’em | Help",
        narrow: true
      }
    },
    {
      path: "/help/equity-calculator",
      component: EquityCalculatorHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Equity Calculator",
        narrow: true
      }
    },
    {
      path: "/help/hit-calculator",
      component: HitCalculatorHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Hit Calculator",
        narrow: true
      }
    },
    {
      path: "/help/equity-matrix",
      component: EquityMatrixHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Equity Matrix",
        narrow: true
      }
    },
    {
      path: "/help/range-constructor",
      component: RangeConstructorHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Range Constructor",
        narrow: true
      }
    },
    {
      path: "/help/should-you-bluff",
      component: ShouldYouBluffHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Should You Bluff",
        narrow: true
      }
    },
    {
      path: "/help/should-you-call",
      component: ShouldYouCallHelp,
      meta: {
        title: "Six Plus Hold’em | Help | Should You Call",
        narrow: true
      }
    },
    {
      path: "/help/breakeven-percentage-for-bluffing-the-turn",
      component: BreakevenPercentageForBluffingTheTurnHelp,
      meta: {
        title:
          "Six Plus Hold’em | Help | Breakeven Percentage For Bluffing The Turn",
        narrow: true
      }
    },
    {
      path: "/help/three-bet-cbet-explorer",
      component: ThreeBetCbetExplorerHelp,
      meta: {
        title: "Six Plus Hold’em | Help | 3bet-Cbet Explorer",
        narrow: true
      }
    },
    {
      path: "/quick-guide",
      component: QuickGuide,
      meta: {
        title: "Six Plus Hold’em | Quick Guide",
        narrow: true
      }
    },
    {
      path: "/beginners-guide",
      component: BeginnersGuide,
      meta: {
        title: "Six Plus Hold’em | Beginners Guide",
        narrow: true
      }
    },
    {
      path: "/made-hands-and-draws",
      component: MadeHandsAndDraws,
      meta: {
        title: "Six Plus Hold’em | Made Hands And Draws Guide",
        narrow: true
      }
    },
    {
      path: "/faq",
      component: PPTFaq,
      meta: {
        title: "Six Plus Hold’em | FAQ",
        narrow: true
      }
    },
    {
      path: "/about",
      component: PPTAbout,
      meta: {
        title: "Six Plus Hold’em | About",
        narrow: true
      }
    },
    {
      path: "/contact",
      component: PPTContact,
      meta: {
        title: "Six Plus Hold’em | Contact",
        narrow: true
      }
    },
    {
      path: "/pricing",
      component: PPTPricing,
      meta: {
        title: "Six Plus Hold’em | Pricing",
        narrow: true
      }
    },
    {
      path: "/short-deck-pricing",
      component: ShortDeckPricing,
      meta: {
        title: "Six Plus Hold’em | Short Deck Pricing",
        narrow: true
      }
    },
    {
      path: "/sign-in",
      component: SignIn,
      meta: {
        title: "Six Plus Hold’em | Sign In",
        requiresLoggedOut: true,
        narrow: true
      }
    },
    {
      path: "/register",
      component: PPTRegister,
      meta: {
        title: "Six Plus Hold’em | Register",
        requiresLoggedOut: true,
        narrow: true
      }
    },
    {
      path: "/forgot-password",
      component: ForgotPassword,
      meta: {
        title: "Six Plus Hold’em | Forgot Password",
        requiresLoggedOut: true,
        narrow: true
      }
    },
    {
      path: "/create-new-password/:token",
      component: CreateNewPassword,
      meta: {
        title: "Six Plus Hold’em | Create New Password",
        requiresLoggedOut: true,
        narrow: true
      }
    },
    {
      path: "/account",
      component: PPTAccount,
      meta: {
        title: "Six Plus Hold’em | Account",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/change-password",
      component: ChangePassword,
      meta: {
        title: "Six Plus Hold’em | Change Password",
        requiresLoggedIn: true,
        narrow: true
      }
    },
    {
      path: "/purchase",
      component: PPTPurchase,
      meta: {
        title: "Six Plus Hold’em | Purchase",
        requiresLoggedIn: true,
        requiresNotBasicOrPremium: true,
        narrow: true
      }
    },
    {
      path: "/purchase-short-deck",
      component: ShortDeckPurchase,
      meta: {
        title: "Six Plus Hold’em | Purchase Short Deck",
        requiresLoggedIn: true,
        requiresNotShortDeckUser: true,
        narrow: true
      }
    },
    {
      path: "/upgrade",
      component: PPTUpgrade,
      meta: {
        title: "Six Plus Hold’em | Upgrade",
        requiresLoggedIn: true,
        iffBasicAuth: true,
        narrow: true
      }
    },

  ]
});

router.beforeEach(function(to, from, next) {
  document.title = to.meta.title;

  if (store.state.account.user.email === undefined) {
    Vue.axios
      .get(`${process.env.BASE_API_URL}/user/me`)
      .then(function(res) {
        return store.commit("account/setUser", res.data.user);
      })
      .catch(function(err) {
        return store.dispatch("account/clearUser");
      })
      .then(function() {
        if (to.meta.requiresLoggedIn && !store.getters["account/loggedIn"]) {
          return next("/sign-in?error=not-logged-in");
        }

        if (to.meta.requiresLoggedOut && store.getters["account/loggedIn"]) {
          return next("/");
        }

        if (
          to.meta.requiresBasicAuth &&
          !store.getters["account/authorizedForBasic"]
        ) {
          return next("/?error=requires-basic-auth");
        }

        if (
          to.meta.requiresPremiumAuth &&
          !store.getters["account/authorizedForPremium"]
        ) {
          return next("/?error=requires-premium-auth");
        }

        if (
          to.meta.iffBasicAuth &&
          !store.state.account.user.auth.includes("basic")
        ) {
          return next("/?error=iff-basic-auth");
        }

        if (
          to.meta.requiresNotBasicOrPremium &&
          store.getters["account/basicOrPremium"]
        ) {
          return next("/?error=already-paid");
        }

        if (
          to.meta.requiresShortDeckAuth &&
          !store.getters["account/authorizedForShortDeck"]
        ) {
          return next("/");
        }

        if (
          to.meta.requiresNotShortDeckUser &&
          store.state.account.user.auth.includes("short deck")
        ) {
          return next("/");
        }

        next();
      });
  } else {
    if (to.meta.requiresLoggedIn && !store.getters["account/loggedIn"]) {
      return next("/sign-in?error=not-logged-in");
    }

    if (to.meta.requiresLoggedOut && store.getters["account/loggedIn"]) {
      return next("/");
    }

    if (
      to.meta.requiresBasicAuth &&
      !store.getters["account/authorizedForBasic"]
    ) {
      return next("/?error=requires-basic-auth");
    }

    if (
      to.meta.requiresPremiumAuth &&
      !store.getters["account/authorizedForPremium"]
    ) {
      return next("/?error=requires-premium-auth");
    }

    if (
      to.meta.iffBasicAuth &&
      !store.state.account.user.auth.includes("basic")
    ) {
      return next("/?error=iff-basic-auth");
    }

    if (
      to.meta.requiresNotBasicOrPremium &&
      store.getters["account/basicOrPremium"]
    ) {
      return next("/?error=already-paid");
    }

    if (
      to.meta.requiresShortDeckAuth &&
      !store.getters["account/authorizedForShortDeck"]
    ) {
      return next("/");
    }

    if (
      to.meta.requiresNotShortDeckUser &&
      store.state.account.user.auth.includes("short deck")
    ) {
      return next("/");
    }

    next();
  }
});

if (process.env.NODE_ENV === "production" && navigator.onLine) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
    router: router,
    set: [{ field: "config", value: "AW-714944788" }]
  });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js